import { graphql } from 'relay-runtime';

export const ActivateRuleMutation = graphql`
  mutation activateRuleMutation(
    $resourceName: String!
    $displayName: String
    $description: String
    $provider: String
    $categories: [String]
    $ruleLibraryItemRef: ValidationRuleLibraryItemRefInput!
    $connectorComponentRef: ConnectorComponentRefInput!
    $generalProperties: [RulePropertyInput!]!
    $specificProperties: [RulePropertyInput]
    $notificationProperties: [RulePropertyInput]
  ) {
    activateValidationRule(
      resourceName: $resourceName
      displayName: $displayName
      description: $description
      provider: $provider
      categories: $categories
      ruleLibraryItemRef: $ruleLibraryItemRef
      connectorComponentRef: $connectorComponentRef
      generalProperties: $generalProperties
      specificProperties: $specificProperties
      notificationProperties: $notificationProperties
    ) {
      name
      displayName
      description
      provider
      ownerRef
      rliType
      rliVersion
      connectorComponentRef {
        kind
        name
        version
      }
      ruleLibraryItemRef {
        kind
        name
        version
        rliType
      }
      checkStatus
      checkStatusMessage
      checkId
      datastoreId
      containerId
      tableRef
    }
  }
`.default;
